//
// HomePage.js
//
// author: marcio.garcia@newsoftware.com.br
//

import React from 'react'
import Content from '../components/Content'
import Header from '../components/Header'
import Footer from '../components/Footer'

class HomePage extends React.Component {
    render() {
        const name = "HOME";

        return (
            <div>
                <Header content={name} />
                <Content content={name} name={name}/>
                <Footer />     
            </div>
        )
    }
}

export default HomePage;
